import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Dashboard.css"; // reuse styles (card, btn, toast, error, etc.)
import api from "../utils/api";


const EMAIL_RE = /.+@.+\..+/;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");

    if (!EMAIL_RE.test(email)) {
      setErr("Enter a valid email.");
      return;
    }

    try {
      setSubmitting(true);
      await api.post("/auth/forgot-password", { email });
      setMsg("If that email exists, we’ve sent a reset link.");
      setEmail("");
    } catch (e) {
      // Always generic (backend also returns generic)
      setMsg("If that email exists, we’ve sent a reset link.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page center-wrap">
      {msg && <div className="toast">{msg}</div>}
      {err && <div className="toast error">{err}</div>}

      <section className="card" style={{ maxWidth: 420, margin: "2rem auto" }}>
        <h2>Seller - Forgot your password?</h2>
        <p className="muted">
          Enter the email you use to sign in. We’ll send you a link to reset it.
        </p>

        <form onSubmit={onSubmit} className="add-form" noValidate>
          <label>
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <button className="btn" type="submit" disabled={submitting}>
            {submitting ? "Sending…" : "Send reset link"}
          </button>
        </form>

        <div style={{ marginTop: "1rem" }}>
          <Link to="/login" className="muted">
            ← Back to login
          </Link>
        </div>
      </section>
    </div>
  );
}

